// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_om-0";
export var animationContainer = "_om-1";
export var itemPrice = "_om-a";
export var itemizedContent = "_om-9";
export var itemizedHeader = "_om-7";
export var itemizedRow = "_om-8";
export var itemizedSection = "_om-6";
export var modalContent = "_om-2";
export var orderName = "_om-3";
export var refundOption = "_om-4";
export var refundOptionsContainer = "_om-5";
export var shippingLabel = "_om-b";
export var totalRow = "_om-c";